import StyleSheet from "react-native-web/dist/exports/StyleSheet";
export const selectFlexStyles = _ref => {
  let {
    alignItems,
    justifyContent,
    flexGrow,
    flexShrink
  } = _ref;
  return {
    alignItems,
    justifyContent,
    flexGrow,
    flexShrink
  };
};
export const staticStyles = StyleSheet.create({
  wrap: {
    flexShrink: 1,
    flexWrap: 'wrap'
  },
  row: {
    flexDirection: 'row'
  },
  'row-reverse': {
    flexDirection: 'row-reverse'
  },
  column: {
    // This is the React Native View default, but also it's very fundamental to the behaviour,
    // so make it explicit and allow it to be tested for.
    flexDirection: 'column'
  },
  'column-reverse': {
    flexDirection: 'column-reverse'
  }
});